import { render, staticRenderFns } from "./goods-traceability-list.vue?vue&type=template&id=196fb1e4&"
import script from "./goods-traceability-list.vue?vue&type=script&lang=js&"
export * from "./goods-traceability-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports